import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormArray, FormGroup } from "@angular/forms";
import { CheckInQuestion } from "@webapp/reflections/models/checkins-models";
import { DeleteCheckInQuestionPayload } from "@webapp/reflections/models/manage-reflections.models";

@Component({
  selector: "manage-reflection-questions",
  templateUrl: "./manage-reflection-questions.component.html",
  styleUrls: ["./manage-reflection-questions.component.less"],
})
export class ManageReflectionQuestionsComponent {
  @Input() public formGroup: FormGroup;
  @Input() public isMoodEnabled: boolean;
  @Input() public isNotesEnabled: boolean;
  @Input() public isCheckInFormEmptyAlertEnabled: boolean;
  @Input() public isOnlyNotesEnabled: boolean;
  @Output() public readonly editModeUpdate = new EventEmitter<{ status: boolean }>();
  @Output() public readonly questionUpdate = new EventEmitter<Partial<CheckInQuestion>>();
  @Output() public readonly questionDelete = new EventEmitter<DeleteCheckInQuestionPayload>();
  @Output() public readonly moodStatusToggle = new EventEmitter<boolean>();
  @Output() public readonly notesStatusToggle = new EventEmitter<boolean>();
  @Output() public readonly questionEditModeEnable = new EventEmitter<string>();
  @Output() public readonly questionsEditModeDisable = new EventEmitter<void>();

  public questionMaxLength = 200;
  public questionLength = 0;
  public isApiUpdateInProgress = false;

  get getQuestions(): FormArray {
    return this.formGroup.controls.questions as FormArray;
  }

  public updateCounter(length: number): void {
    this.questionLength = length;
  }

  public enableQuestionEditMode(questionId: string, length: number): void {
    this.questionEditModeEnable.emit(questionId);
    this.editModeUpdate.emit({ status: true });
    this.updateCounter(length);
  }

  public disableQuestionsEditMode(): void {
    this.questionsEditModeDisable.emit();
  }

  public updateQuestion(question: Partial<CheckInQuestion>, index: number): void {
    if (this.formGroup.controls.questions.status === "VALID") {
      if (!this.isApiUpdateInProgress) {
        this.questionUpdate.emit(question);
        this.editModeUpdate.emit({ status: false });
      }
    } else {
      this.deleteQuestion({ questionId: question.id, index });
    }

    this.disableQuestionsEditMode();
  }

  public deleteQuestion({ questionId, index }: DeleteCheckInQuestionPayload): void {
    this.questionDelete.emit({ questionId, index });
    this.editModeUpdate.emit({ status: false });
  }

  public toggleMoodStatus(isEnabled: boolean): void {
    this.moodStatusToggle.emit(isEnabled);
  }

  public toggleNotesStatus(isEnabled: boolean): void {
    this.notesStatusToggle.emit(isEnabled);
  }
}
